const doc = [({"ko":({"adminConstantAdminUserRoleType":({"admin":"관리자", "general":"일반 사용자", "onlyProperty":"최근 사용자"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;